import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        header: {
            display: 'grid',
            gridTemplateColumns:'0.01fr 1fr 0.01fr',
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            alignItems:'center',
            '& .arrowBack': {
                width:'24px',
                height:'24px',
                textDecoration:'none',
                color: 'black'
            },
            '& .title': {
                textAlign: 'center'
            },
            [theme.breakpoints.down('md')]: {
                '& .title': {
                    fontSize: '1.5rem'
                }
            }
        },
        addressGrid: {
            width: '100%',
            '& .addressPaper': {
                padding: '0px 30px'
            },
            '& button': {
                margin: '1rem 0rem'
            }
        },
        scheduleGrid: {
            width: '100%',
            '& .schedulePaper': {
                padding: '10px 30px 70px 30px'
            }
        },
        orderSummaryGrid: {
            width: '100%',
            '& .orderSummaryPaper': {
                padding: '10px 30px',
                height: '320px'
            }
        },
        orderTotal: {
            color: '#000000',
            fontWeight: 'bold'
        },
        couponGrid: {
            width: '100%', 
            marginTop: '47px',
            '& .couponPaper': {
                padding: '25px 30px'
            },
            [theme.breakpoints.down('xs')]: {
                marginTop: '0px'
            }
        },
        productsContainer: {
            height: '100%',
            overflow: 'none',
            [theme.breakpoints.up('md')]: {
                height: '250px',
                overflow: 'scroll'
            }
        },
        productsPaper: {
            padding: '20px',
            [theme.breakpoints.down('xs')]: {
                padding: '20px 0px'
            }
        },
        productsBox: {
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center'
        },
        productImage: {
            width: '80px',
            height: '80px'
        },
        productNotAvailable: {
            color: 'red',
            textDecoration: 'line-through'
        },
        productQty: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: 1,
            borderRadius: '50%',
            backgroundColor: '#000000',
            color: 'white',
            width: '3rem',
            height: '3rem'
        },
        productQtyNoAvailable: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: 1,
            borderRadius: '50%',
            backgroundColor: 'red',
            color: 'white',
            width: '3rem',
            height: '3rem'
        },
        notchedOutline: {
            borderWidth: "1px",
            borderColor: "yellow !important"
        },
        redColor: {
            color: 'red'
        },
        button: {
            display: 'none',
            backgroundColor: '#D32F2F', 
            marginTop: '10px',
            [theme.breakpoints.up('md')]: {
                display: 'block'
            }
        },
        floatingButton: {
            display: 'none',
            backgroundColor: '#D32F2F', 
            position: 'sticky',
            bottom: '1rem',
            [theme.breakpoints.down('sm')]: {
                display: 'block'
            }
        },
        snackBar: {
            display: 'none',
            marginTop: '75px',
            [theme.breakpoints.down('sm')]: {
                display: 'flex'
            }
        },
        alert: {
            display: 'none',
            [theme.breakpoints.up('md')]: {
                display: 'flex'
            }
        },
        cartItemsDesktop: {
            display: 'none',
            [theme.breakpoints.up('md')]: {
                display: 'block'
            }
        },
        cartItemsMobile: {  
            display: 'none',
            [theme.breakpoints.down('sm')]: {
                display: 'block'
            },
            '& .MuiAccordionDetails-root': {
                display: 'block'
            }
        }
    })
);

export const orderConfirmationStyles = makeStyles((theme: Theme) =>
    createStyles({
        image: {
            display: 'block',
            marginTop: '2rem',
            margin: 'auto',
            width: '80%',
            [theme.breakpoints.down('sm')]: {
                display: 'block',
                margin: 'auto',
                marginTop: '1rem',
                width: '80%'
            }
        },
        orderId: {
            color: '#5A5A5A',
            fontSize: '2.5rem',
            fontFamily: 'Cormorant Garamond',
            fontWeight: 'bold',
            textAlign: 'center',
            margin: '24px 0px 24px 0px',
            [theme.breakpoints.down('sm')]: {
                fontSize: '2rem'
            }
        },
        paragraphContent: {
            color: '#5A5A5A',
            fontSize: '2.5rem',
            fontFamily: 'Cormorant Garamond',
            fontWeight: 'bold',
            textAlign: 'center',
            margin: '12px 0px 24px 0px',
            [theme.breakpoints.down('sm')]: {
                fontSize: '2rem'
            }
        },
        button: {
            backgroundColor: '#D32F2F',
            fontWeight: 600,
            fontFamily: 'Hind Siliguri'
        },
        successIcon: {
            color: 'green',
            fontSize: '3rem'
        }
    })
);